var _excluded = ["children", "initialValues", "onSubmit", "validationSchema", "noValidate"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { Formik, Form as FormikForm } from 'formik';
import { jsx as ___EmotionJSX } from "@emotion/react";
/**
 * A drop-in Formik Form wrapper that can be used with the FormElement component
 */
var Form = _ref => {
  var {
      children,
      initialValues,
      onSubmit = () => {},
      validationSchema,
      noValidate
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return ___EmotionJSX(Formik, _extends({
    initialValues: initialValues,
    onSubmit: onSubmit,
    validationSchema: validationSchema
  }, props), formikProps => ___EmotionJSX(FormikForm, {
    noValidate: noValidate,
    "data-testid": "sp-ui-form"
  }, children instanceof Function ? children(formikProps) : children));
};
export default Form;